import { bugsnag } from 'shared/utils/services/bugsnag';

export const retryTracker = ({
  callbackFn,
  context = '',
  retry = 5,
  trackerKey = '',
}: {
  callbackFn: () => void;
  context?: string;
  retry?: number;
  trackerKey?: string;
}) => {
  // NOTE: Do not fire if one trust advertising category is blocked or SSR
  if (
    (window?.OptanonActiveGroups && !window?.OptanonActiveGroups?.includes('C0004')) ||
    typeof window === 'undefined'
  ) {
    return { status: 'window not ready' };
  }

  /**
   * NOTE: Sometimes third-party object is not initialized in time for the tracker, therefore
   * retry a max of 5 times
   */
  if (!window[trackerKey] && retry > 0) {
    setTimeout(
      () => {
        retryTracker({ callbackFn, context, retry: retry - 1, trackerKey });
      },
      1000 * 2 ** (5 - retry),
    );

    return { status: 'retry' };
  }

  try {
    callbackFn();
    return { status: 'success' };
  } catch (error) {
    /**
     * NOTE: notify bugsnag of all errors except for when snaptr is undefined after
     * 5 retries. The cause of snaptr can be for a number of reasons and tends to
     * happen only on production but even then cannot reproduce.
     */
    if (retry > 0) {
      const errorMessage = (error as Error)?.message;

      bugsnag(
        `Error firing retry function: ${errorMessage}. retry count: ${retry}. context: ${context}`,
        {
          context: 'tracking',
          severity: 'warning',
        },
      );
    }
  }
  return { status: 'error' };
};
